import { CashOrThreeMonthEnum, FixingDateEvent, PricePointEnum, WhoFixesDateEnum } from 'api';
import { yup } from 'form';

export const variablePricingSchema = yup.object().shape({
  cash_or_three_month: yup
    .string()
    .oneOf(Object.values(CashOrThreeMonthEnum))
    .when('is_variable_pricing', {
      is: true,
      otherwise: (schema) => schema.optional(),
      then: (schema) => schema.required('Cash or 3-month average is required for variable pricing'),
    }),
  fixing_date: yup.string().when(['is_variable_pricing', 'who_fixes_date'], {
    is: (isVariablePricing: boolean, whoFixesDate: WhoFixesDateEnum) =>
      isVariablePricing === true && whoFixesDate === WhoFixesDateEnum.FIXED_DATE,
    otherwise: (schema) => schema.optional(),
    then: (schema) =>
      schema.required("Fixing date is required when using variable pricing and 'Who fixes date' is set to FIXED DATE"),
  }),
  fixing_date_end_event: yup
    .string()
    .oneOf(Object.values(FixingDateEvent))
    .when(['is_variable_pricing', 'who_fixes_date'], {
      is: (isVariablePricing: boolean, whoFixesDate: WhoFixesDateEnum) =>
        isVariablePricing === true && whoFixesDate !== WhoFixesDateEnum.FIXED_DATE,
      otherwise: (schema) => schema.optional(),
      then: (schema) => schema.required('Fixing date event end is required for variable pricing with a non-fixed date'),
    }),
  fixing_date_end_offset: yup.number().when(['is_variable_pricing', 'who_fixes_date'], {
    is: (isVariablePricing: boolean, whoFixesDate: WhoFixesDateEnum) =>
      isVariablePricing === true && whoFixesDate !== WhoFixesDateEnum.FIXED_DATE,
    otherwise: (schema) => schema.optional(),
    then: (schema) => schema.required('Fixing date offset end is required for variable pricing with a non-fixed date'),
  }),
  fixing_date_start_event: yup
    .string()
    .oneOf(Object.values(FixingDateEvent))
    .when(['is_variable_pricing', 'who_fixes_date'], {
      is: (isVariablePricing: boolean, whoFixesDate: WhoFixesDateEnum) =>
        isVariablePricing === true && whoFixesDate !== WhoFixesDateEnum.FIXED_DATE,
      otherwise: (schema) => schema.optional(),
      then: (schema) =>
        schema.required('Fixing date event start is required for variable pricing with a non-fixed date'),
    }),
  fixing_date_start_offset: yup.number().when(['is_variable_pricing', 'who_fixes_date'], {
    is: (isVariablePricing: boolean, whoFixesDate: WhoFixesDateEnum) =>
      isVariablePricing === true && whoFixesDate !== WhoFixesDateEnum.FIXED_DATE,
    otherwise: (schema) => schema.optional(),
    then: (schema) =>
      schema.required('Fixing date offset start is required for variable pricing with a non-fixed date'),
  }),
  index: yup.string().when('is_variable_pricing', {
    is: true,
    otherwise: (schema) => schema.optional(),
    then: (schema) => schema.required('Index is required for variable pricing'),
  }),
  is_variable_pricing: yup.boolean().required(),
  price_as_percentage_of_index: yup.string().when('is_variable_pricing', {
    is: true,
    otherwise: (schema) => schema.optional(),
    then: (schema) => schema.required('Price as percentage of index is required for variable pricing'),
  }),
  price_point: yup
    .string()
    .oneOf(Object.values(PricePointEnum))
    .when('is_variable_pricing', {
      is: true,
      otherwise: (schema) => schema.notRequired(),
      then: (schema) => schema.required('Price post is required for fixed pricing'),
    }),
  who_fixes_date: yup
    .string()
    .oneOf(Object.values(WhoFixesDateEnum))
    .when('is_variable_pricing', {
      is: true,
      otherwise: (schema) => schema.optional(),
      then: (schema) => schema.required('Who fixes date is required for variable pricing'),
    }),
});
